import { LoadingButton } from '@mui/lab'
import { Box, Divider, Paper, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { TextFieldNumber } from 'src/_modules/common'
import { ROLES } from 'src/constants'

export default function SelectAmountCard({
    custom = false,
    value,
    onConfirm,
    loading,
    buttonTitle = "Select",
    textFieldProps = {}
}) {
    const { t } = useTranslation()
    const {profile} = useSelector(state => state.entities.profile)

    const [customValue, setCustomValue] = useState('')

    const confirmHandler = () => {
        if (custom && !!customValue) {
            onConfirm(Number(customValue))
        } else {
            onConfirm(value)
        }
    }

    const limitValidation = ()=>{
        if(customValue < 20 && profile?.role !== ROLES.admin){
            return true
        }
        return false
    }

    return (
        <Paper>
            <Box py={4} height={100} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                {
                    (custom && !value) ?
                        <TextFieldNumber
                            label={t("Amount")}
                            value={customValue}
                            variant="outlined"
                            // placeholder={t("Enter amount more than 20")}
                            size="small"
                            onChange={({ target: { value } }) => setCustomValue(value)}
                            {...textFieldProps}
                        />
                        :
                        <Typography textAlign="center" variant="h6" color="primary">
                            {`${value} ${t("Currency")}`}
                        </Typography>
                }
                <Typography textAlign="center" variant="caption" color="secondary">
                    {t("This price does not include tax.")}
                </Typography>
            </Box>
            <Divider />
            <Box>
                <LoadingButton
                    disabled={(custom && limitValidation()) || loading}
                    onClick={confirmHandler}
                    fullWidth
                    color="primary"
                    loading={loading}
                    sx={{ textTransform: "none" }}
                >
                    {t(buttonTitle)}
                </LoadingButton>
            </Box>
        </Paper>
    )
}
